// TODO: Refactor. This component replaced for anchor tag and Link component
// TODO: improvement. This component just cover few cases, we need to improve it
import React, { CSSProperties, ComponentPropsWithRef } from 'react';
import { LinkRouterProps, Link } from '@anytag/router';
import { cn } from '@anytag/shared-utils';
import { TextCutter } from '../TextCutter';

interface BaseAnchorProps extends ComponentPropsWithRef<'a'> {
  lines?: number;
  disabled?: boolean;
  className?: string;
  label?: string | null;
  variant?: 'default' | 'blue' | 'inherit';
  style?: CSSProperties;
  title?: string;
}

export type InternalLinkProps = LinkRouterProps;
type ExternalLinkProps = Pick<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  'onClick' | 'href' | 'target' | 'rel' | 'onMouseEnter' | 'onMouseLeave'
>;

export type AnchorPropsInternal = InternalLinkProps & BaseAnchorProps;
export type AnchorProps = BaseAnchorProps & ExternalLinkProps & InternalLinkProps;

// 1. Define type-safe variants
const VARIANTS = ['default', 'blue', 'inherit'] as const;
type Variant = (typeof VARIANTS)[number];

// 2. Use real color tokens from @colors.css
const variantClasses: Record<Variant, string> = {
  default: cn('text-zinc-900 hover:text-blue-70'),
  blue: cn('text-blue-70 hover:text-blue-70'),
  inherit: cn('text-inherit')
};

export const Anchor = ({
  ref,
  lines,
  target,
  onClick,
  children,
  disabled,
  label = '',
  variant = 'default',
  to,
  href,
  className,
  ...restProps
}: Omit<AnchorProps, 'variant'> & { variant?: Variant }) => {
  const customDisabled = disabled || (!(href || to) && !onClick);
  const mergedClassName = cn(
    'flex cursor-pointer items-center',
    variantClasses[variant],
    customDisabled && 'pointer-events-none cursor-not-allowed',
    className
  );
  const commonProps = {
    ref,
    target,
    disabled: customDisabled,
    className: mergedClassName,
    onClick:
      !(href || to) && !onClick
        ? (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
          }
        : onClick
  };
  const content = children || <TextCutter text={label} lines={lines} className={cn('flex-1 text-inherit')} />;

  if (href) {
    return (
      <a {...commonProps} href={href} rel="noopener noreferrer">
        {content as React.ReactNode}
      </a>
    );
  } else {
    const { state, replace, search, params, href, ...rest } = restProps as InternalLinkProps;
    return (
      <Link {...commonProps} to={to} state={state} replace={replace} search={search} params={params} {...rest}>
        {content}
      </Link>
    );
  }
};
